import { render, staticRenderFns } from "./ShopUser.vue?vue&type=template&id=2c806626"
import script from "./ShopUser.vue?vue&type=script&lang=js"
export * from "./ShopUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports